function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVigilTmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "154px",
    height: "25px",
    viewBox: "0 0 154 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 199.109,
    y1: 228.068,
    x2: 96.4701,
    y2: 228.149,
    gradientTransform: "matrix(0.174241,0,0,0.174265,-16.738102,-14.986756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.352941%,42.352941%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(13.333333%,13.333333%,13.333333%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 72.9642,
    y1: 185.625,
    x2: 173.78,
    y2: 186.447,
    gradientTransform: "matrix(0.174241,0,0,0.174265,-16.738102,-14.986756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.352941%,42.352941%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(1.960784%,62.745098%,98.039216%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 33.164062 10.042969 L 37.179688 21.464844 L 41.15625 10.042969 L 44.1875 10.042969 L 38.5625 24.894531 L 35.78125 24.894531 L 30.132812 10.042969 Z M 33.164062 10.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 58.320312 24.894531 L 58.320312 10.042969 L 61.207031 10.042969 L 61.207031 24.894531 Z M 58.320312 24.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 83.023438 25 C 82.0625 25 81.148438 24.804688 80.28125 24.414062 C 79.433594 24.023438 78.679688 23.488281 78.023438 22.804688 C 77.382812 22.105469 76.882812 21.296875 76.519531 20.375 C 76.15625 19.457031 75.972656 18.460938 75.972656 17.386719 C 75.972656 16.367188 76.15625 15.414062 76.519531 14.519531 C 76.882812 13.613281 77.390625 12.820312 78.046875 12.136719 C 78.699219 11.453125 79.46875 10.914062 80.347656 10.523438 C 81.222656 10.132812 82.179688 9.9375 83.210938 9.9375 C 84.605469 9.9375 85.796875 10.238281 86.789062 10.839844 C 87.792969 11.425781 88.542969 12.207031 89.046875 13.179688 L 86.890625 14.769531 C 86.515625 14.03125 85.984375 13.46875 85.300781 13.078125 C 84.632812 12.6875 83.902344 12.492188 83.105469 12.492188 C 82.480469 12.492188 81.90625 12.625 81.390625 12.886719 C 80.875 13.152344 80.429688 13.515625 80.054688 13.976562 C 79.675781 14.4375 79.382812 14.964844 79.175781 15.566406 C 78.980469 16.164062 78.882812 16.800781 78.882812 17.46875 C 78.882812 18.179688 78.988281 18.835938 79.195312 19.4375 C 79.417969 20.035156 79.726562 20.558594 80.117188 21.003906 C 80.519531 21.449219 80.988281 21.804688 81.515625 22.070312 C 82.046875 22.320312 82.632812 22.449219 83.273438 22.449219 C 84.027344 22.449219 84.746094 22.253906 85.429688 21.863281 C 86.125 21.472656 86.773438 20.898438 87.371094 20.148438 L 87.371094 22.992188 C 86.132812 24.332031 84.683594 25 83.023438 25 Z M 87.164062 19.371094 L 84.171875 19.371094 L 84.171875 17.261719 L 89.546875 17.261719 L 89.546875 24.894531 L 87.164062 24.894531 Z M 87.164062 19.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 104.554688 24.894531 L 104.554688 10.042969 L 107.441406 10.042969 L 107.441406 24.894531 Z M 104.554688 24.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 123.089844 24.894531 L 123.089844 10.042969 L 125.976562 10.042969 L 125.976562 22.363281 L 133.546875 22.363281 L 133.546875 24.894531 Z M 123.089844 24.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 147.667969 0 L 147.667969 0.59375 L 145.992188 0.59375 L 145.992188 4.96875 L 145.308594 4.96875 L 145.308594 0.59375 L 143.636719 0.59375 L 143.636719 0 Z M 147.667969 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 148.960938 0 L 149.925781 0 L 151.355469 4.203125 L 152.769531 0 L 153.726562 0 L 153.726562 4.96875 L 153.085938 4.96875 L 153.085938 2.035156 C 153.085938 1.933594 153.085938 1.765625 153.09375 1.53125 C 153.097656 1.296875 153.097656 1.046875 153.097656 0.777344 L 151.683594 4.96875 L 151.015625 4.96875 L 149.589844 0.777344 L 149.589844 0.929688 C 149.589844 1.050781 149.589844 1.238281 149.59375 1.488281 C 149.601562 1.738281 149.605469 1.917969 149.605469 2.035156 L 149.605469 4.96875 L 148.960938 4.96875 Z M 148.960938 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "url(#linear0)"
    },
    d: "M 11.15625 11.277344 C 7.398438 17.769531 6.171875 19.921875 6.171875 20.027344 C 6.171875 20.136719 8.175781 23.691406 8.828125 24.742188 C 8.949219 24.9375 9.234375 24.929688 9.351562 24.734375 L 9.796875 23.957031 C 10.183594 23.289062 12.15625 19.878906 14.179688 16.375 C 16.203125 12.871094 17.878906 9.964844 17.898438 9.914062 C 17.917969 9.863281 16.59375 9.835938 14.953125 9.851562 L 13.582031 9.863281 C 12.582031 9.875 11.660156 10.414062 11.15625 11.277344 Z M 11.15625 11.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "url(#linear1)"
    },
    d: "M 9.089844 14.863281 C 8.503906 13.851562 7.816406 12.664062 7.015625 11.277344 C 6.515625 10.414062 5.59375 9.875 4.589844 9.863281 L 3.222656 9.851562 C 1.582031 9.835938 0.253906 9.863281 0.277344 9.914062 C 0.296875 9.964844 1.96875 12.871094 3.996094 16.375 C 6.019531 19.878906 7.992188 23.289062 8.375 23.957031 L 8.824219 24.734375 C 8.9375 24.929688 9.222656 24.9375 9.34375 24.742188 C 9.691406 24.179688 10.425781 22.910156 11.03125 21.828125 L 15.050781 14.867188 C 14.453125 15.894531 13.34375 16.585938 12.070312 16.585938 C 10.796875 16.585938 9.683594 15.894531 9.089844 14.863281 Z M 9.089844 14.863281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigilTmLogo);
export default __webpack_public_path__ + "static/media/vigilTMLogo.6eb1b3d014d6c1b981d8c34c10e7100c.svg";
export { ForwardRef as ReactComponent };